/**
 * Fetch Latest User Roadmap Item UseCase
 *
 * Thin delegator for the post-add reload: fetches the current user's most
 * recently created roadmap item (or `null` when the user has none). Forwards
 * `userId` to `roadmapService.fetchLatestUserRoadmapItem` and returns its
 * result unchanged. No business logic lives here — the Firestore query and the
 * DTO→entity mapping (plus like-state fill) stay in the service.
 *
 * Flutter parity:
 *  - lib/presentation/screens/roadmap/roadmap_screen.dart:145
 *    (_onAddRoadmapItemTapped): `RoadmapRepository().getLatestUserRoadmapItem()`
 *    returns a nullable item that the screen inserts at the top of the list.
 *    Flutter calls the repository directly; the web wraps it in this use case
 *    per conventions.md Clean-Architecture flow.
 */

import { roadmapService } from '@/domain/services/roadmap/roadmapService';
import type { RoadmapItemEntity } from '@/domain/entities/roadmap/roadmapItemEntity';

export class FetchLatestUserRoadmapItemUseCase {
  async execute(userId: string): Promise<RoadmapItemEntity | null> {
    return roadmapService.fetchLatestUserRoadmapItem(userId);
  }
}

export const fetchLatestUserRoadmapItemUseCase = new FetchLatestUserRoadmapItemUseCase();
